{
  "names": {
    "Fajr": "Subuh",
    "Dhuhr": "Zuhur",
    "Asr": "Asar",
    "Maghrib": "Magrib",
    "Isha": "Isya"
  },
  "card": {
    "label": "Salat berikutnya",
    "labelTomorrow": "Besok · {{prayer}}",
    "inHoursMinutes": "dalam {{hours}} j {{minutes}} mnt",
    "inMinutes": "dalam {{minutes}} mnt",
    "open_aria": "Buka waktu salat",
    "pro": "Rhemn Pro",
    "unlock_aria": "Buka waktu salat dengan Rhemn Pro",
    "unavailable": "Jadwal salat tidak tersedia saat ini."
  },
  "sheet": {
    "bellOn_aria": "Matikan pengingat {{prayer}}",
    "bellOff_aria": "Nyalakan pengingat {{prayer}}",
    "explainer": "Dapatkan pengingat lembut di setiap salat. Pengingat berupa notifikasi senyap — tanpa suara secara bawaan.",
    "enableReminders": "Aktifkan pengingat",
    "enableInSettings": "Aktifkan notifikasi Rhemn di Pengaturan untuk menerima pengingat salat.",
    "openSettings": "Buka Pengaturan"
  },
  "notifications": {
    "body": "Waktunya salat."
  },
  "focus": {
    "label": "Salat {{prayer}}",
    "close_aria": "Tutup layar salat",
    "hint": "Tekan Esc atau × untuk kembali",
    "phrases": {
      "accepted": "Semoga Allah menerima salat Anda",
      "acceptedAr": "تقبّل الله صلاتك"
    }
  },
  "ambient": {
    "default": "Mulai dengan niat. Lanjutkan dengan keberkahan.",
    "prayerApproaches": "Waktu salat Anda berikutnya hampir tiba. Tetaplah berpegang pada niat Anda.",
    "morningPursue": "Pagi yang penuh berkah untuk mengejar: {{focus}}",
    "dayCloses": "Saat hari berakhir, renungkan: {{focus}}",
    "fulfilled": "Anda telah memenuhi niat Anda hari ini. Alhamdulillah.",
    "workingTowards": "Hari ini Anda sedang mengupayakan: {{focus}}",
    "prayerNear": "Waktu salat Anda berikutnya sudah dekat. Tarik napas sejenak."
  },
  "widget": {
    "countdown": "dalam {{time}}",
    "openToUpdate": "Buka Rhemn untuk memperbarui",
    "openForVerse": "Buka Rhemn untuk ayat hari ini"
  }
}
